import { render } from "./TaskUpdateForm.vue?vue&type=template&id=40944402&scoped=true"
import script from "./TaskUpdateForm.vue?vue&type=script&lang=js"
export * from "./TaskUpdateForm.vue?vue&type=script&lang=js"

import "./TaskUpdateForm.vue?vue&type=style&index=0&id=40944402&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40944402"]])

export default __exports__